import { render, staticRenderFns } from "./anticorrosionInsulationDetail.vue?vue&type=template&id=63bb71d2&scoped=true"
import script from "./anticorrosionInsulationDetail.vue?vue&type=script&lang=js"
export * from "./anticorrosionInsulationDetail.vue?vue&type=script&lang=js"
import style0 from "./anticorrosionInsulationDetail.vue?vue&type=style&index=0&id=63bb71d2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63bb71d2",
  null
  
)

export default component.exports